

import Gha_Profile from "./Gha_Profile";
import Gha_Welcome from "./Gha_Welcome";

import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT, protocol } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import Loader from "../../UI/loader";

import { scrollToTop } from "../../../JS/scrollToTop";
import Axios from "axios";
import { GHAwelcomePagefetchHTML } from "../../../action/gha";
import {  fetchAvailableLanguages } from "../../../action/gha";

export const ghaSelectedProfileLSKey = "GhaSelectedProfile";
export const ghaAllProfilesLSKey = "GhaAllProfiles";

//LS profile interface is
// {
//     firstName,
//     lastName,
//     profileId,
//     membershipColor
//     membershipNumber
// }

// DO MAKE SURE TO USE JSON.STRIGIFY WHILE SETING IN LS 

const validateGhaALLProfileLS = () => {
    if (!localStorage.getItem(ghaAllProfilesLSKey) || localStorage.getItem(ghaAllProfilesLSKey) == "null") {
        return false;
    }

    const lsData = JSON.parse(localStorage.getItem(ghaAllProfilesLSKey));

    lsData.forEach(aProfileData => {
        ["firstName", "lastName", "profileId", "membershipColor", "membershipNumber"].forEach((field) => {
            if (!aProfileData.hasOwnProperty(field)) {
                return false;
            }
        })
    })

    return true;
}


export const validateGhaSelectedProfileLS = () => {
    if (!localStorage.getItem(ghaSelectedProfileLSKey) || localStorage.getItem(ghaSelectedProfileLSKey) == "null") {
        return false;
    }

    const lsData = JSON.parse(localStorage.getItem(ghaSelectedProfileLSKey));

    ["firstName", "lastName", "profileId", "membershipColor", "membershipNumber"].forEach((field) => {
        if (!lsData.hasOwnProperty(field)) {
            return false;
        }
    })

    return true;
}




function GHA(props) {
    const {t}=props;

    // saving all profiles data and selected profile data in local storage

    const [shouldRenderComponents, setShouldRenderComponents] = useState(false);
    const [allProfilesData, setAllProfilesData] = useState([])


    const [currentPage, setCurrentPage] = useState(1);
    const [isNewJoin, setIsNewJoin] = useState(false);


    const [pageContent, setPageContent] = useState(null);
 

    const [fetchingLang, setFetchinglang]=useState(false);
    const [availableLanguages,setAvailableLanguages]=useState([])

    const [requiredLinks,setRequiredLinks]=useState({tncLink:"",ppLink:"", deleteAccountLink:""})
    const [isLangFetchingFailed, setIsLangFetchingFailed]=useState(false);


    let widgetSesstionId = localStorage.getItem("ghaSessionToken");
    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });

    const sendAnalytic = (isSuccess, task, res) => {
        props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            `${task} response ${isSuccess ? 'Success' : "failed"}`,
            {
                ...label,
                layoutTab: props.currentHomePage.tabName,
                element: "widget",
                widgetSessionId: widgetSesstionId,
                errorStatus: JSON.stringify(res),
                errorMessage: JSON.stringify(
                    res
                ),
            },
            0,
            props.guestIsLoggedIn
        );
    }


    const handleNextToProfileInfo = (profileInfo) => {
        console.log("handleNextToProfileInfo called, ProfileInfo:", profileInfo)
        localStorage.setItem(ghaAllProfilesLSKey, JSON.stringify(profileInfo));
        setAllProfilesData(profileInfo);
        //set localstroage also for ALL
    }

    const startFlow = () => {
        setShouldRenderComponents(false);
        setAllProfilesData([]);


        if (validateGhaALLProfileLS()) {
            setAllProfilesData(JSON.parse(localStorage.getItem(ghaAllProfilesLSKey)))
        }
        setShouldRenderComponents(true);
    }

    const handleLogoutUser = () => {
        console.log("logout clicked..")
        localStorage.removeItem(ghaSelectedProfileLSKey)
        localStorage.removeItem(ghaAllProfilesLSKey)
        startFlow();
    }

    const getAvailableLanguages=()=>{
        setFetchinglang(true);
        
        fetchAvailableLanguages()
        .then(res=>{
            if(res.status==200 && res.data.payload && res.data.payload.data && res.data.payload.tncLink && res.data.payload.ppLink && res.data.payload.deleteAccountRequestUrl ){
                setAvailableLanguages(res.data.payload.data);
                setRequiredLinks({
                    tncLink:res.data.payload.tncLink,
                    ppLink:res.data.payload.ppLink,
                    deleteAccountLink:res.data.payload.deleteAccountRequestUrl,
                })
                
                sendAnalytic(true,"GET available languages")
            }
            else{
                 throw new Error();
                // props.closeOrderPopUp(true, t('gha.errors.getAvailableLanguages'), "", true)
                // sendAnalytic(false, "GET available languages", res)
            }
        })
        .catch((err)=>{
             
            setIsLangFetchingFailed(true);
            props.closeOrderPopUp(true, t('gha.errors.getAvailableLanguages'), "", true)
            sendAnalytic(false, "GET available languages", err)

        })
        .finally(()=>{
            setFetchinglang(false);
        })
    }
  


    const handleGoBack = () => {
        if (currentPage == 1) {
            props.setGoHome(true);
            return;
        }
        if (currentPage == 2) {
            setCurrentPage(1)
            return;
        }

    }

    const handleNext = (isNewJoin, profilesData) => {
        if (currentPage == 1) {
            setIsNewJoin(isNewJoin);
            setCurrentPage(2)
            return;
        }
        // currentPage is 2
        if (isNewJoin) {

            const formattedProfileData =
            {
                firstName: profilesData.firstName,
                lastName: profilesData.lastName,
                profileId: profilesData.profileId,
                membershipColor: profilesData.membershipLevel || "",
                membershipNumber: profilesData.membershipCardNo || ''
            }
            handleNextToProfileInfo([formattedProfileData])

        } else {

            let formattedProfilesData = [];
            profilesData.forEach((profile) => {
                formattedProfilesData.push({
                    firstName: profile.firstName,
                    lastName: profile.lastName,
                    profileId: profile.profileId,
                    membershipNumber: profile.membershipNumber || '',
                    membershipColor: profile.membershipLevel || ''
                })
            })

            handleNextToProfileInfo(formattedProfilesData)


        }

    }


    useEffect(() => {
        startFlow()
    }, [])



  
    useEffect(async() => {
        
        scrollToTop();
        try{
            setFetchinglang(false);
            setIsLangFetchingFailed(false);
            getAvailableLanguages();

            const response= await GHAwelcomePagefetchHTML();
            setPageContent(response);
        }catch(err){
            sendAnalytic(false,"Gha Welcome Page Html",err)
            props.closeOrderPopUp(true, (err ) || t('gha.errors.something_went_wrong'), "", true)
            props.setGoHome(true);

        }
       


    }, []);





    return (
        <>

            <div >
                

                {
                    shouldRenderComponents
                        ? ((allProfilesData.length == 0)

                            ?
                            // include  welcome page + login + signup
                            <Gha_Welcome handleNextToProfileInfo={handleNextToProfileInfo} pageContent={pageContent} handleNext={handleNext} handleGoBack={handleGoBack} currentPage={currentPage} isNewJoin={isNewJoin} fetchingLang={fetchingLang} availableLanguages={availableLanguages} requiredLinks={requiredLinks} isLangFetchingFailed={isLangFetchingFailed} />
                            :
                            // include account selection + profile info
                            <Gha_Profile allProfilesData={allProfilesData} handleLogoutUser={handleLogoutUser} requiredLinks={requiredLinks} />)
                        :<>
                        <div></div>
                            <Loader displayMsg={"Loading.."} showClose={true} close={()=>props.setGoHome(true)}  />
                        </> 


                }
            </div>
        </>
    )
}

//welcome page (login , signup) - NO,  ALL PROFILE DATA
//ACCOUT SELECTION - IF ALL PROFILE , BUT NOT SINGLE PROFILE
// profile info()   - IF BOTH

//for switch, just remove SINGLE PROFILE and use ALL to do api call

// LOGIN is when you have SINGLE PROFILE
//for logout- remove SINGLE


// at accont infor, we have switch button, we are just removing SINGLE , and going to CHOOSE ACCT page ( logged out phase)
//
const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
         logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(mapStateToProps, { setGoHome ,closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(GHA)
);